import * as React from 'react';

import { verifyTurnstileToken } from 'api';

interface UseTurnstileValidationResult {
  validateToken: (token: string) => Promise<boolean>;
  isValidating: boolean;
}

export function useTurnstileValidation(): UseTurnstileValidationResult {
  const [isValidating, setIsValidating] = React.useState(false);

  const validateToken = React.useCallback(
    async (token: string): Promise<boolean> => {
      setIsValidating(true);
      try {
        const verificationResult = await verifyTurnstileToken(token);
        return verificationResult.success;
      } catch (err) {
        return false;
      } finally {
        setIsValidating(false);
      }
    },
    [],
  );

  return { validateToken, isValidating };
}
